import React from "react";

const Pic = ({ data }) => {
    return (
        <div className={`flex flex-col justify-between lg:p-6 p-5 bg-no-repeat bg-contain bg-bottom border-solid rounded-2xl lg:w-[38%] md:w-[30%] md:h-full md:min-w-52 h-[428px]`} style={{ backgroundImage: data.bg_img, backgroundColor: data.bg_pic }}>

            <div className={`flex flex-col font-medium gap-4`} style={{ color: data.pic_txt }}>

                <span className="lg:text-[28px] md:text-[22px] text-[28px]">{data.title_pic}</span>

                <span className="text-[14px]">{data.description_pic}</span>

            </div>


            <a href={data.webAppLink} target="balck" className={`flex gap-2 max-w-[190px] justify-between items-center lg:px-6 px-4 py-2 border-solid rounded-full `} style={{ backgroundColor: data.bg_button }}>

                <span className="text-nowrap">{data.button_txt}</span>

                <img className="w-6 h-6 p-1.5" src={data.button} alt="" />

            </a>


        </div>
    );
};

export default Pic;